import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { Auth } from '../../../../autentication/Auth';
import { User } from '../../../../autentication/models/user';
import { ListItem } from '../../../../shared/list-confirmation/model/list-item';
import { Util } from '../../../../utils/util';
import { PixKeysService } from '../../keys/keys.service';
import { PixGenerateQrCode } from '../../models/generate-qrcode.model';
import { PixKeyType } from '../../models/key-type.enum';
import { PixKey } from '../../models/key.model';
import { PixQrCode } from '../../models/qr-code.model';

@Component({
	selector: 'app-pix-receive-payment-qr-code',
	templateUrl: './qr-code-resume.component.html',
	styleUrls: ['./qr-code-resume.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixReceivePaymentQrCodeComponent implements OnInit {

	public user: User;
	public pixGenerateQrCode: PixGenerateQrCode;
	public qrCode: PixQrCode;
	public value = 0;
	public date = '';

	constructor(
		private router: Router,
		private pixKeysService: PixKeysService,
		private snackBar: MatSnackBar,
		) {}

	ngOnInit(): void {
		this.pixGenerateQrCode = this.pixKeysService.getPixGenerateQrCode();
		this.qrCode = this.pixKeysService.getPixQrCode();
		this.checkParams() ? this.goBack() : '';
		this.user = Auth.getInstance().getUser();
		this.buildList();
	}

	checkParams(): boolean {
		return this.pixGenerateQrCode === undefined ||
					this.pixGenerateQrCode.codigo === undefined ||
					this.pixGenerateQrCode.tipoChave === undefined ||
					this.qrCode === undefined ||
					this.qrCode.codigo === undefined;
	}

	buildList() {
	}

	copyMessage(val: string) {
		Util.copyToClipboard(val);
		this.showSnack();
  }

	showSnack() {
		this.snackBar.open('Copiado', 'Ok', {
			duration: 2000,
		});
	}

	get keyType(): typeof PixKeyType {
		return PixKeyType;
	}

	generate() {}
	emitPrint = () => window.print();
	emitNew = () => this.router.navigate(['pix/receber']);
	goBack = () => this.router.navigate(['pix/receber']);
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/receive-payment/qr-code/qr-code-resume.component.ts